'use client';

import { CSSProperties, useCallback, useSyncExternalStore } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface NavLinkProps {
  to: string;
  children: React.ReactNode | ((props: { isActive: boolean }) => React.ReactNode);
  style?: CSSProperties;
  className?: string;
}

export const NavLink = ({ to, children, style, className, ...props }: NavLinkProps) => {
  const pathname = usePathname();
  const isClient = useSyncExternalStore(
    useCallback(() => () => {}, []),
    () => true,
    () => false
  );

  // Always render as inactive during SSR to match initial client render
  const isActive =
    isClient && pathname ? pathname === to || (to !== '/' && pathname.startsWith(to)) : false;

  const content = typeof children === 'function' ? children({ isActive }) : children;

  return (
    <Link href={to} style={style} className={className} {...props} suppressHydrationWarning>
      {content}
    </Link>
  );
};
